import AbstractEntity from "../AbstractEntity";

export default class Client extends AbstractEntity {
    _id;
    _name;
    _phoneMobile;
    _phoneHome;
    _email;
    _line1;
    _line2;
    _postcode;
    _city;
    _latitude;
    _longitude;
    _orderId;


    getId() {
        return this._id;
    }

    getName() {
        return this._name;
    }

    getPhoneMobile() {
        return this._phoneMobile;
    }

    getPhoneHome() {
        return this._phoneHome;
    }

    getEmail() {
        return this._email;
    }

    getLine1() {
        return this._line1;
    }

    getLine2() {
        return this._line2;
    }

    getPostcode() {
        return this._postcode;
    }

    getCity() {
        return this._city;
    }

    getLatitude() {
        return this._latitude;
    }

    getLongitude() {
        return this._longitude;
    }

    getOrderId() {
        return this._orderId;
    }

    getClassName() {
        return "client";
    }
}
